import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "./reviewer.css";
import ReviewerService from "../../services/reviewer.service";
import Header from "../../components/header/Header";
import Preloader from "../../components/preloader/Preloader";
import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { baseURL } from "../../common/constants";
import DocumentModal from "../../components/DocumentModal";
import { Document, Page, pdfjs } from "react-pdf";
import AmountForm from "./AmountForm";
import TenorForm from "./TenorForm";
import toast from "react-hot-toast";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const Reviewer = () => {
	const { user } = useContext(AuthContext);
	const { projectID } = useParams();
	const [fetching, setFetching] = useState(false);
	const [isDisabled, setIsDisabled] = useState(false);
	const [projectData, setProjectData] = useState({});
	const [initiatorData, setInitiatorData] = useState({});
	const [showImage, setShowImage] = useState(false);
	const [viewBidDoc, setViewBidDoc] = useState(false);
	const [viewExecDoc, setViewExecDoc] = useState(false);
	const [viewOfferDoc, setViewOfferDoc] = useState(false);
	const [viewVerifyDoc, setViewVerifyDoc] = useState(false);
	const [showAmountForm, setShowAmountForm] = useState(false);
	const [showTenorForm, setShowTenorForm] = useState(false);

	const getProject = async (id) => {
		setFetching(true);
		let res = await ReviewerService.reviewerProject(id);
		const data = res.data.project;
		console.log(data);
		const _data = res.data.initiator;
		setProjectData(data);
		setInitiatorData(_data);
		setFetching(false);
	};

	useEffect(() => {
		getProject(projectID);
	}, [projectID]);

	const [numPages, setNumPages] = useState(null);
	const onDocumentLoadSuccess = ({ numPages }) => {
		setNumPages(numPages);
	};

	const handleStatus = async (e) => {
		e.preventDefault();
		setIsDisabled(true);
		try {
			const _status = { reviewerRejected: true };
			let res = await ReviewerService.updateProjectStatus(projectData._id, _status);
			if (res.data.success === true) {
				toast.success(res.data.msg);
				setIsDisabled(false);
			}
		} catch (err) {
			toast.error(err);
		}
	};

	const handleReview = async (e) => {
		e.preventDefault();
		try {
			const _review = { reviewed: true };
			let res = ReviewerService.updateProjectReview(projectData._id, _review);
			if (res.data.success === true) {
				toast.success(res.data.msg);
				setIsDisabled(false);
			}
		} catch (err) {
			toast.error(err);
		}
	};

	return (
		<div className="action__page">
			<Header />
			<div className="review__page__heading">REVIEW DESK</div>
			<div className="project__initiator__review">
				<div className="card-wrapper">
					<div className="card-container">
						<div className="card--header">PROJECT TITLE</div>
						<div className="card">
							<div className="card-heading">{projectData.title}</div>
							<div className="review__image-wrapper">
								<img
									src={`${baseURL}/files/image/${projectData.image}`}
									alt="project"
								/>
							</div>
							<button
								className="card-submit__button"
								variant="primary"
								onClick={() => setShowImage(true)}
							>
								View
							</button>
						</div>
					</div>

					<div className="card-container">
						<div className="card--header">PURPOSE OF PROJECT</div>
						<div className="card">
							<div className="card-heading">{projectData.title}</div>
							<p className="card-paragraph">{projectData.purpose}</p>
							<button className="card-submit__button">Read more</button>
						</div>
					</div>

					<div className="card-container">
						<div className="card--header">PROJECT TENOR</div>
						<div className="card">
							<div className="card-inside">
								<div className="tenor-input review__card-info">
									<div
										className={`${projectData.tenor === "2" ? "isSelected" : ""}`}
									></div>{" "}
									2 Years
								</div>
								<div className="tenor-input review__card-info">
									<div
										className={`${projectData.tenor === "4" ? "isSelected" : ""}`}
									></div>{" "}
									4 Years
								</div>
								<div className="tenor-input review__card-info">
									<div
										className={`${projectData.tenor === "6" ? "isSelected" : ""}`}
									></div>{" "}
									6 Years
								</div>
								<div className="tenor-input review__card-info">
									<div
										className={`${projectData.tenor === "8" ? "isSelected" : ""}`}
									></div>{" "}
									8 Years
								</div>
								<div className="tenor-input review__card-info">
									<div
										className={`${projectData.tenor === "10" ? "isSelected" : ""}`}
									></div>{" "}
									10 Years
								</div>
								<div className="tenor-input review__card-info">
									<div
										className={`${projectData.tenor === "12" ? "isSelected" : ""}`}
									></div>
									12 Years
								</div>
							</div>
							<button
								className="card-submit__button"
								onClick={() => setShowTenorForm(true)}
							>
								Review
							</button>
						</div>
					</div>

					<TenorForm
						projectData={projectData}
						show={showTenorForm}
						onHide={() => setShowTenorForm(false)}
					/>

					<div className="card-container">
						<div className="card--header">PROJECT AMOUNT</div>
						<div className="card">
							<div
								className="card-heading"
								style={{
									display: "flex",
									flexDirection: "row",
									alignItems: "center",
									justifyContent: "space-between",
								}}
							>
								PARTIAL PAYMENT{" "}
								<div className="review__card-info">
									&#x20A6;{" "}
									<span>
										{projectData.partialAmount === undefined || null || ""
											? ""
											: projectData.partialAmount
													.toString()
													.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
									</span>
								</div>
							</div>
							<p className="card-span" style={{ marginLeft: "70px" }}></p>
							<div
								className="card--heading"
								style={{
									marginTop: "20px",
									display: "flex",
									flexDirection: "row",
									alignItems: "center",
									justifyContent: "space-between",
								}}
							>
								FULL PAYMENT
								<div className="review__card-info">
									&#x20A6;{" "}
									{projectData && (
										<span>
											{projectData.fullAmount === undefined || null || ""
												? ""
												: projectData.fullAmount
														.toString()
														.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
										</span>
									)}
								</div>
							</div>
							<button
								className="card-submit__button"
								onClick={() => setShowAmountForm(true)}
							>
								Review
							</button>
						</div>
					</div>
					<AmountForm
						projectData={projectData}
						show={showAmountForm}
						onHide={() => setShowAmountForm(false)}
					/>

					<div className="card-container">
						<div className="card--header">PROJECT CONTRACTOR</div>
						<div className="card">
							<div className="card-heading">{projectData.companyName}</div>
							<p className="reviewer__card-paragraph">{projectData.companySummary}</p>
							<button className="card-submit__button">
								<a
									href={projectData.companyWebsite}
									target="_blank"
									rel="noopener noreferrer"
								>
									View Profile
								</a>
							</button>
						</div>
					</div>

					<div className="card-container">
						<div className="card--header">DOCUMENTS UPLOADED</div>
						<div className="card">
							<div className="card-heading">
								<div className="reviewer__card-inside">
									<div className="upload-btn" onClick={() => setViewBidDoc(true)}>
										View Bid Documents
									</div>
									<div className="upload-btn" onClick={() => setViewExecDoc(true)}>
										View Executive Summary
									</div>
									<div
										className="upload-btn"
										style={{ paddingLeft: "5px", paddingRight: "5px" }}
										onClick={() => setViewOfferDoc(true)}
									>
										View Signed Offer
									</div>
									<div className="upload-btn" onClick={() => setViewVerifyDoc(true)}>
										View Verification Documents
									</div>
								</div>
							</div>
						</div>
					</div>
					<p className="reviewer__review__note-info">
						N.B. KINDLY REVIEW BEFORE APPROVING
					</p>
				</div>
				<div className="reviewer__action-btns">
					<button onClick={handleStatus} disabled={isDisabled}>
						REJECT
					</button>
					<button onClick={handleReview} disabled={isDisabled}>
						SUBMIT
					</button>
				</div>
				{initiatorData && (
					<p className="initiator">
						INITIATED BY:{" "}
						{initiatorData.firstname === undefined ||
						initiatorData.firstname === null ||
						!initiatorData
							? ""
							: initiatorData.firstname.toUpperCase()}{" "}
						{initiatorData.lastname === undefined ||
						initiatorData.lastname === null ||
						!initiatorData
							? ""
							: initiatorData.lastname.toUpperCase()}{" "}
						{initiatorData.staffnum === undefined ||
						initiatorData.staffnum === null ||
						!initiatorData
							? ""
							: initiatorData.staffnum.toUpperCase()}
					</p>
				)}
				<p className="reviewer">
					REVIEWED BY: {user.firstname.toUpperCase()}{" "}
					{user.lastname.toUpperCase()} {user.staffnum.toUpperCase()}
				</p>
			</div>
			<DocumentModal
				heading={"Project Image"}
				show={showImage}
				onHide={() => setShowImage(false)}
			>
				<img src={`${baseURL}/files/image/${projectData.image}`} alt="project" />
			</DocumentModal>
			<DocumentModal
				heading={"Bid Document"}
				show={viewBidDoc}
				onHide={() => setViewBidDoc(false)}
			>
				<Document
					file={`${baseURL}/files/file/${projectData.bidDocument}`}
					onLoadSuccess={onDocumentLoadSuccess}
				>
					{" "}
					{Array.from(new Array(numPages), (el, index) => (
						<Page key={`page_${index + 1}`} pageNumber={index + 1} />
					))}{" "}
				</Document>
			</DocumentModal>
			<DocumentModal
				heading={"Executive Summary Document"}
				show={viewExecDoc}
				onHide={() => setViewExecDoc(false)}
			>
				<Document
					file={`${baseURL}/files/file/${projectData.executiveSummary}`}
					onLoadSuccess={onDocumentLoadSuccess}
				>
					{" "}
					{Array.from(new Array(numPages), (el, index) => (
						<Page key={`page_${index + 1}`} pageNumber={index + 1} />
					))}{" "}
				</Document>
			</DocumentModal>
			<DocumentModal
				heading={"Offer Document"}
				show={viewOfferDoc}
				onHide={() => setViewOfferDoc(false)}
			>
				<Document
					file={`${baseURL}/files/file/${projectData.offerDocument}`}
					onLoadSuccess={onDocumentLoadSuccess}
				>
					{" "}
					{Array.from(new Array(numPages), (el, index) => (
						<Page key={`page_${index + 1}`} pageNumber={index + 1} />
					))}{" "}
				</Document>
			</DocumentModal>
			<DocumentModal
				heading={"Verification Document"}
				show={viewVerifyDoc}
				onHide={() => setViewVerifyDoc(false)}
			>
				<Document
					file={`${baseURL}/files/file/${projectData.verificationDocument}`}
					onLoadSuccess={onDocumentLoadSuccess}
				>
					{" "}
					{Array.from(new Array(numPages), (el, index) => (
						<Page key={`page_${index + 1}`} pageNumber={index + 1} />
					))}{" "}
				</Document>
			</DocumentModal>
			{fetching && <Preloader text={"Fetching data"} />}
		</div>
	);
};

export default Reviewer;
